{
  "el": {
    "issue_category": {
      "labels": {
        "backup_category": "Κατηγορία αντικατάστασης",
        "category_name": "Όνομα κατηγορίας",
        "delete_category": "Διαγραφή κατηγορίας «{name}»;",
        "delete_category_disclaimer": "Όλες οι παρατηρήσεις με αυτή την κατηγορία θα ανατεθούν ξανά στην κατηγορία που θα επιλέξεις παρακάτω.",
        "integration_warning": "Υπάρχει ενεργή ενσωμάτωση με την ενότητα Παρατηρήσεων στην πλατφόρμα σου. Αν θέλεις να δημιουργήσεις ή να επεξεργαστείς κατηγορίες, ζήτησέ το μας.",
        "new_category": "Κατηγορία"
      }
    }
  }
}
